import { meAction } from '../../actions/login'

export const authLoader = async () => {

    await meAction()
    return null

}